import tbIntervalOptions from '@/lib/options/tb-interval'

const getCustomFacet = (key, value) => {
  let customFacet = null

  switch (key) {
    case 'meta.tbInterval': {
      customFacet = tbIntervalOptions.find(option => option.value === value)
      break
    }
  }

  return customFacet
}

export default getCustomFacet
